'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _SelectWidget = require('../Overrided/widgets/SelectWidget');

var _SelectWidget2 = _interopRequireDefault(_SelectWidget);

var _UpDownWidget = require('../Overrided/widgets/UpDownWidget');

var _UpDownWidget2 = _interopRequireDefault(_UpDownWidget);

var _DateTimeInputWidget = require('../Overrided/widgets/DateTimeInputWidget');

var _DateTimeInputWidget2 = _interopRequireDefault(_DateTimeInputWidget);

var _JSONSchemaForm = require('../Overrided/JSONSchemaForm');

var _JSONSchemaForm2 = _interopRequireDefault(_JSONSchemaForm);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _reactScrollToComponent = require('react-scroll-to-component');

var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);

var _utils = require('../../utils');

var _formBuilder = require('../../utils/formBuilder.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.FormsServiceWidget = {
  serverErrors: {},
  components: {}

  /* eslint-disable react/no-multi-comp */
};
//import Form from 'react-jsonschema-form'

var CustomFieldTemplate = function (_React$Component) {
  (0, _inherits3.default)(CustomFieldTemplate, _React$Component);

  function CustomFieldTemplate() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomFieldTemplate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomFieldTemplate.__proto__ || (0, _getPrototypeOf2.default)(CustomFieldTemplate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isDirty: false,
      isFocused: false,
      isActive: false
    }, _this.onChange = function (e) {
      var value = _this.props.children.props.formData;
      if (value && value.length) {
        _this.setState({ isActive: true });
      } else {
        _this.setState({ isActive: false });
      }
    }, _this.onFocus = function (e) {
      _this.setState({ isFocused: true });
      if (_this.props.uiSchema['ui:widget'] === 'dateTime') {
        var elem = e.target;
        setTimeout(function () {
          try {
            var windowHeight = document.documentElement.clientHeight;
            var datePickerTop = elem.getBoundingClientRect().top;
            var datePickerWindowHeight = document.getElementsByClassName('rdtPicker')[0].offsetHeight;

            if (windowHeight - datePickerTop <= datePickerWindowHeight) {
              (0, _reactScrollToComponent2.default)(elem, { offset: 0, align: 'top', duration: 800 });
            }
          } catch (e) {
            console.log('Error focus dateTime', e);
          }
        }, 100);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomFieldTemplate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.FormsServiceWidget.components[this.props.id] = {
        forceUpdate: this.forceUpdate.bind(this)
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var widgetType = this.props.uiSchema['ui:widget'];
      var children = nextProps.children,
          schema = nextProps.schema,
          uiSchema = nextProps.uiSchema,
          formContext = nextProps.formContext,
          id = nextProps.id;

      var currentValue = this.props.children.props.formData;
      var nextValue = children.props.formData;
      var state = formContext.formControlState[id];
      if (state === 'touched' || state === 'dirty') {
        this.setState({ isDirty: true });
      } else {
        this.setState({ isDirty: false });
      }
      if (currentValue !== nextValue) {
        switch (widgetType) {
          case 'dateTime':
            {
              var dateTimeWidget = this.ref;
              if (nextValue && nextValue !== '__.__.____ __:__' && currentValue !== '__.__.____ __:__') {
                setTimeout(function () {
                  // Зачем?! В обход стейта реакта?!
                  //dateTimeWidget.getElementsByClassName('rdt')[0].classList.remove('rdtOpen');
                });
                this.setState({ isActive: true });
              } else {
                this.setState({ isActive: false });
              }
              break;
            }
          case 'select':
            {
              if (nextValue) {
                this.setState({ isActive: true });
              } else {
                this.setState({ isActive: false });
              }
              break;
            }
          default:
            break;
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          id = _props.id,
          classNames = _props.classNames,
          label = _props.label,
          help = _props.help,
          required = _props.required,
          description = _props.description,
          errors = _props.errors,
          children = _props.children,
          hideLabel = _props.schema.hideLabel,
          uiSchema = _props.uiSchema,
          formContext = _props.formContext;
      var _state = this.state,
          isDirty = _state.isDirty,
          isFocused = _state.isFocused,
          isActive = _state.isActive;

      var showErrors = uiSchema['ui:widget'] === 'phoneInput' ? !isFocused : true;

      var serverErrors = window.FormsServiceWidget.serverErrors[id] || [];

      var isHidden = window.fs_hidden_fields.indexOf(id) !== -1;

      return _react2.default.createElement(
        'div',
        {
          style: { display: isHidden ? 'none' : '' },
          className: classNames + (isFocused ? ' focus ' : '') + (isActive ? ' active ' : ''),
          onFocus: this.onFocus,
          onBlur: function onBlur() {
            return _this2.setState({ isFocused: false });
          },
          onKeyUp: this.onChange,
          ref: function ref(node) {
            _this2.ref = node;
          }
        },
        !hideLabel && label ? _react2.default.createElement('label', {
          htmlFor: id,
          dangerouslySetInnerHTML: { // eslint-disable-line react/no-danger
            __html: '' + label + (required ? '*' : '')
          }
        }) : null,
        description,
        children,
        showErrors && errors,
        serverErrors.length > 0 && _react2.default.createElement(
          'ul',
          { className: 'form-widget__error-detail form-widget__bs-callout form-widget__bs-callout-info' },
          serverErrors.map(function (error, index) {
            return _react2.default.createElement(
              'li',
              { key: 'server_error__' + index, className: 'form-widget__text-danger' },
              error
            );
          })
        ),
        help
      );
    }
  }]);
  return CustomFieldTemplate;
}(_react2.default.Component);

var makeSubmutRequest = function makeSubmutRequest(data) {
  var formData = data.formData,
      _data$uiSchema = data.uiSchema,
      formMetaData = _data$uiSchema.formMetaData,
      onSubmit = _data$uiSchema.onSubmit,
      onError = _data$uiSchema.onError,
      formId = _data$uiSchema.formId,
      dataProcessor = _data$uiSchema.dataProcessor;
  var submitUrl = formMetaData.submitUrl,
      _formMetaData$submitM = formMetaData.submitMethod,
      submitMethod = _formMetaData$submitM === undefined ? 'POST' : _formMetaData$submitM;


  var gaClientID = window && window.ga && typeof window.ga.getAll === 'function' && window.ga.getAll()[0].get('clientId');
  var metadata = _ramda2.default.filter(_ramda2.default.identity, {
    gaClientID: gaClientID
  });

  return (0, _isomorphicFetch2.default)(submitUrl, {
    method: submitMethod,
    headers: {
      'Content-Type': 'application/json'
    },
    body: (0, _stringify2.default)(dataProcessor((0, _assign2.default)(formData, (0, _keys2.default)(metadata).length && { metadata: metadata })))
  });
};

function isComponentInViewport(el) {
  // В случае если ошибка "плоская" элемент отсутствует
  if (!el) {
    return;
  }

  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
  return isVisible;
}

var widgets = {
  UpDownWidget: _UpDownWidget2.default,
  DateTimeInputWidget: _DateTimeInputWidget2.default,
  SelectWidget: _SelectWidget2.default
};

var FormPreview = function (_React$Component2) {
  (0, _inherits3.default)(FormPreview, _React$Component2);

  function FormPreview() {
    var _ref2;

    var _temp2, _this3, _ret2;

    (0, _classCallCheck3.default)(this, FormPreview);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FormPreview.__proto__ || (0, _getPrototypeOf2.default)(FormPreview)).call.apply(_ref2, [this].concat(args))), _this3), _this3.onError = function () {
      var elem = document.getElementsByClassName((_this3.props.cssPrefix || '') + 'form-widget__field-error')[0];
      if (!isComponentInViewport(elem)) (0, _reactScrollToComponent2.default)(elem, { offset: 0, align: 'top', duration: 800 });
      _this3.props.schemaData.onError();
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret2);
  }

  (0, _createClass3.default)(FormPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var onInit = this.props.schemaData.onInit;


      onInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$schemaData = _props2.schemaData,
          _props2$schemaData$sc = _props2$schemaData.schema,
          schema = _props2$schemaData$sc.schema,
          uiSchema = _props2$schemaData$sc.uiSchema,
          onSubmit = _props2$schemaData.onSubmit,
          onError = _props2$schemaData.onError,
          onInit = _props2$schemaData.onInit,
          dataProcessor = _props2$schemaData.dataProcessor,
          submitMessage = _props2$schemaData.submitMessage,
          cssPrefix = _props2.cssPrefix,
          formId = _props2.formId,
          i18nInstance = _props2.i18nInstance,
          i18nPath = _props2.i18nPath,
          preset = _props2.preset,
          hidden = _props2.hidden,
          onChange = _props2.onChange;
      var submitUrl = uiSchema.formMetaData.submitUrl;

      var context = { i18nInstance: i18nInstance, i18nPath: i18nPath };

      if (cssPrefix) {
        context.cssPrefix = cssPrefix;
      }

      if (formId) {
        context.formId = formId;
      }

      var fieldSettings = (0, _utils.getFieldSettings)(this.props.schemaData.form);

      var queryParams = (0, _formBuilder.getQueryParams)();

      var formDataFromQuery = (0, _formBuilder.getFormDataFromQueryParams)(schema, uiSchema, queryParams);
      var formDataFromFieldSettings = (0, _formBuilder.getFormDataFromQueryParams)(schema, uiSchema, fieldSettings.preset || {});
      var formDataFromPresets = (0, _formBuilder.getFormDataFromQueryParams)(schema, uiSchema, preset || {});
      var formDataWithSingleValues = (0, _formBuilder.getFormDataForFieldsWithSingleValue)(schema, uiSchema, formId);

      var formData = (0, _extends3.default)({}, formDataWithSingleValues, formDataFromQuery, formDataFromFieldSettings, formDataFromPresets);
      return _react2.default.createElement(_JSONSchemaForm2.default, {
        action: submitUrl,
        method: 'POST',
        widgets: widgets,
        preset: preset || {},
        formId: formId,
        changeSchema: this.props.changeSchema,
        schema: schema,
        formData: formData,
        uiSchema: (0, _extends3.default)({}, uiSchema, {
          onSubmit: onSubmit,
          onError: onError,
          dataProcessor: dataProcessor
        }),
        showErrorList: false,
        onSubmit: makeSubmutRequest,
        onChange: onChange,
        onError: this.onError,
        transformErrors: _utils.transformErrors,
        formContext: (0, _keys2.default)(context) ? context : null,
        noHtml5Validate: true,
        noValidate: false,
        FieldTemplate: CustomFieldTemplate,
        validate: (0, _utils.customValidate)(uiSchema),
        submitMessage: this.props.schemaData.submitMessage,
        liveValidate: true,
        validateOnBlur: true
      });
    }
  }]);
  return FormPreview;
}(_react2.default.Component);

FormPreview.propTypes = {
  schemaData: _react.PropTypes.object.isRequired,
  cssPrefix: _react.PropTypes.string,
  formId: _react.PropTypes.string,
  i18nInstance: _react.PropTypes.object,
  i18nPath: _react.PropTypes.string,
  preset: _react.PropTypes.object,
  hidden: _react.PropTypes.array,
  onChange: _react.PropTypes.func
};

FormPreview.defaultProps = {
  cssPrefix: undefined,
  formId: undefined,
  i18nInstance: undefined,
  i18nPath: undefined,
  preset: {},
  hidden: [],
  onChange: _utils.noop
};

exports.default = FormPreview;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Viewer/index.js
// module id = 1124
// module chunks = 5